var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageAbove(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_712_3440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.25 0.75H1.75C0.79 0.75 0 1.54 0 2.5V14C0 14.96 0.79 15.75 1.75 15.75H22.25C23.21 15.75 24 14.96 24 14V2.5C24 1.54 23.21 0.75 22.25 0.75ZM1.5 2.5C1.5 2.36 1.61 2.25 1.75 2.25H22.25C22.39 2.25 22.5 2.36 22.5 2.5V7.24L20.2 5.19C19.52 4.58 18.47 4.61 17.8 5.26L12.2 10.87L11.88 10.93C11.86 10.92 11.84 10.91 11.82 10.89L8.21 7.28C7.54 6.61 6.47 6.59 5.78 7.23L1.5 11.19V2.5Z",
    fill: "#99439D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 17.75H0.75C0.336 17.75 0 18.086 0 18.5C0 18.914 0.336 19.25 0.75 19.25H23.25C23.664 19.25 24 18.914 24 18.5C24 18.086 23.664 17.75 23.25 17.75Z",
    fill: "#CCA3CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 21.25H0.75C0.336 21.25 0 21.586 0 22C0 22.414 0.336 22.75 0.75 22.75H23.25C23.664 22.75 24 22.414 24 22C24 21.586 23.664 21.25 23.25 21.25Z",
    fill: "#CCA3CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 24.75H0.75C0.336 24.75 0 25.086 0 25.5C0 25.914 0.336 26.25 0.75 26.25H23.25C23.664 26.25 24 25.914 24 25.5C24 25.086 23.664 24.75 23.25 24.75Z",
    fill: "#CCA3CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_712_3440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25.5,
    fill: "white",
    transform: "translate(0 0.75)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageAbove);
export default __webpack_public_path__ + "static/media/ImageAbove.a9d692059e3f98dc4e994e6684f1b53b.svg";
export { ForwardRef as ReactComponent };